import { setDefaultAssets } from '@leagueplatform/asset-config';
import { DISCLIAMER_ASSETS } from './asset-map';

export const initModule = () => {
  setDefaultAssets(DISCLIAMER_ASSETS);
};
